<template>
  <div>
    <v-select ref="select" v-model="code"
              @keypress.enter.native.prevent=""
              label="title"
              placeholder="Выберите ЕГК код"
              :filterable="false"
              class="search_input"
              @input="selectCode"
              :appendToBody="true"
              :options="codes"
              @search="searchCode">
      <template slot="no-options">
        введите название препарата..
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center text-wrap">
          ({{ option.id }}) {{ option.title }} <span class="color_red" v-if="option.invalid">не активный</span>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="text-wrap">
          ({{ option.id }}) {{ option.title }} <span class="color_red" v-if="option.invalid">не активный</span>
        </div>
      </template>
    </v-select>
    <div class="mt-1" v-if="!hideDetails">
      <div class="alert alert-info">
        <p class="mb-0">Спеццена: 1/2 значит 100 сайт : 200 справ, а 2/1 значит 100 сайт : 50 справ</p>
      </div>
      <div v-for="(c, index) in details" class="code_block" v-if="!c.id.to_delete">
        <div class="input-group">
          <div class="input-group-prepend egk_div">
            <span class="input-group-text egk_title">{{ c.title.value }}</span>
          </div>
          <input type="text" class="form-control not_valid_code mw-85" disabled
                 :value="c.invalid ? 'не активен' : null">
          <input type="text" class="form-control mw-85" disabled v-model="c.id.value">
          <div class="input-group-append">
            <button class="btn btn-outline-danger" @click="removeCode(+c.id.value)" type="button">
              <i class="icon-fa icon-fa-trash"/>
            </button>
          </div>
        </div>
        <div class="mt-1">
          <clip-loader
            v-if="loadingRates[index]"
            class="text-center"
            :loading="true"
            :color="$constants.LOADING_COLOR"
            size="20px"
          ></clip-loader>
          <template v-if="!loadingRates[index] && codeRates[c.id.value]">
            <div class="input-group">
              <input type="number" placeholder="k-1" class="form-control small_field"
                     v-model="codeRates[c.id.value].rate_1">
              <span class="pl-2 pr-2 m-auto">/</span>
              <input type="number" placeholder="k-2" class="form-control small_field"
                     v-model="codeRates[c.id.value].rate_2">
              <input type="text" class="form-control" placeholder="комментарий" v-model="codeRates[c.id.value].comment">
              <div class="input-group-append">
                <button class="btn btn-outline-success" @click="updateEgkRate(+c.id.value)" type="button">
                  <i class="icon-fa icon-fa-save"></i></button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import vSelect from 'vue-select';

export default {
  props: ['details', 'updateDetail', 'hideDetails'],
  components: {
    vSelect
  },
  data() {
    return {
      code: null,
      codes: [],
      loadingRates: {},
      codeRates: {},
    }
  },
  mounted() {
    this.getEgkRate((this.details || []).map((d) => d.id.value));
  },
  methods: {
    async updateAllCodes() {
      this.details.forEach(async (c) => {
        if (!c.id.to_delete) {
          await this.updateEgkRate(+c.id.value, true);
        }
      })
    },
    removeCode(id) {
      if (this.updateDetail) {
        const index = this.details.findIndex((d) => +d.id.value === id)
        if (index !== -1) {
          this.details[index].id.to_delete = true;
          this.details[index].title.to_delete = true;
        }
        this.updateDetail([...this.details])
      }
    },
    async updateEgkRate(code, silent = false) {
      const {data} = await api.post('/egk/rates', {
        action: 'update',
        record: this.codeRates[code]
      })
      if (data.success) {
        if (!silent)
          toastr['success'](data.message || 'Обновлено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    },
    selectCode(code) {
      if (!this.details && this.updateDetail) {
        this.updateDetail(code);
      }
      if (!this.details) return;
      this.details.push({
        ...code,
        id: {
          value: code.id,
          type: 'int'
        },
        title: {
          value: code.title,
          type: 'text',
        }
      });
      if (this.updateDetail) {
        this.updateDetail([...this.details])
      }
      this.code = null;
      const selected = this.details.map((d) => d.id.value)
      this.codes = this.codes.filter((r) => !selected.includes(r.id));
      this.getEgkRate([code.id]);
    },
    searchCode(search, loading) {
      if (!search || search.length < 3) return;
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce(async (loading, search, vm) => {
      if (!search) return;
      const {data} = await api.index('egk/search?q=' + encodeURIComponent(search));
      let sugg = [];
      if (data.success && data.records && data.records.length) {
        const selected = (vm.details || []).map((d) => d.id.value)
        sugg = data.records.filter((r) => !selected.includes(r.id));
      }
      vm.codes = sugg ?? [];
      loading(false);
    }, 700),
    async getEgkRate(codesIds) {
      if (!codesIds || !codesIds.length) return;
      codesIds.forEach((c) => {
        const index = this.details.findIndex((code) => +code.id.value === +c);
        this.loadingRates[index] = true;
      })
      this.loadingRates = {...this.loadingRates}
      const {data} = await api.post('/egk/rates', {
        action: 'info',
        codes: codesIds
      })
      if (data.success) {
        codesIds.forEach((c) => {
          if (!data.records[c]) {
            data.records[c] = {
              egk_id: c
            }
          }
        })
        this.codeRates = {...this.codeRates, ...data.records};
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      Object.keys(this.loadingRates).forEach((i) => this.loadingRates[i] = false)
    }
  }
}
</script>

<style scoped>
.mw-85 {
  max-width: 85px;
  height: auto;
}

.egk_title {
  width: 100%;
  white-space: normal;
}

.egk_div {
  width: calc(100% - 220px);
}

.color_red {
  color: red;
}

.btn i {
  text-align: center;
}

.code_block .input-group {
  justify-content: space-between;
}

.small_field {
  width: 100px;
  max-width: 100px;
}

.code_block {
  margin-bottom: 10px;
  border: 1px solid lightgray;
  padding: 9px 4px;
}

.not_valid_code {
  color: red;
}

span {
  text-align: left;
}
</style>
